import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import ErrorIcon from '@material-ui/icons/ErrorRounded';
import { withStyles } from '@material-ui/core/styles';

import { styles } from './styles';

import { DialogStateContext } from './index';

function DeleteDialog (props) {
    const { classes, handleClose, handleDelete, form } = props;
    return (
        <DialogStateContext.Consumer>
            {dialogState => (
                <Dialog
                    open={dialogState.open}
                    onClose={handleClose}
                    fullWidth
                >
                    <div className={classes.header}>
                        <Typography variant="h6" color="inherit">
                            <ErrorIcon className={classes.icon} />
                            Delete Form
                        </Typography>
                    </div>
                    <DialogContent className={classes.content}>
                        <Typography variant="subtitle1">Are you sure you want to delete this form?</Typography>
                        <Typography variant="subtitle2" className={classes.formName}>{form.name}</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>cancel</Button>
                        <Button className={classes.deleteBtn} onClick={handleDelete}>
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </DialogStateContext.Consumer>
    );
}

export default withStyles(styles)(DeleteDialog);
